import API from './index';

const api = {
    getAuthorizedDomain() {
        return API.basicAPI({
            url: '/authorized-domain',
            method: 'GET',
            params: null,
        });
    },
    createAuthorizedDomain(data) {
        return API.authAPI({
            url: '/authorized-domain',
            method: 'POST',
            data,
        });
    },
    deleteAuthorizedDomain(id) {
        return API.authAPI({
            url: `/authorized-domain/${id}`,
            method: 'DELETE',
            params: null,
        });
    },
    updateAuthorizedDomain(data) {
        return API.authAPI({
            url: `/authorized-domain/${data.id}`,
            method: 'PATCH',
            data: { email: data.email, enable: data.enable },
        });
    },
};

export default api;
